<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M388.2 64.1C405.2 64.1 421.4 70.9 433.4 82.9L557.6 206.9C569.6 218.9 576.3 235.2 576.4 252.1L576.4 387.7C576.4 404.7 569.6 420.9 557.6 432.9L433.5 557.2C421.5 569.2 405.2 575.9 388.3 575.9L252.7 575.9C235.7 575.9 219.4 569.2 207.5 557.2L83.3 433C71.3 421 64.5 404.8 64.5 387.8L64.5 252.2C64.5 235.2 71.3 218.9 83.2 207L207.4 82.8C219.4 70.8 235.7 64.1 252.6 64L388.2 64zM438.4 209.8C427.7 202 412.7 204.4 404.9 215.1L285.5 379.3L233.4 327.2C224 317.8 208.8 317.8 199.5 327.2C190.2 336.6 190.1 351.8 199.5 361.1L271.5 433.1C276.5 438.1 283.3 440.6 290.3 440.1C297.3 439.6 303.7 436 307.8 430.3L443.8 243.3C451.6 232.6 449.2 217.6 438.5 209.8z"
      fill="currentColor"
    />
  </svg>
</template>
